module.exports = "/_next/static/images/sellersFone-aa2f73ebf92736c581469a11b26b4ab9.png";